import { render, staticRenderFns } from "./BatchesDropDown.vue?vue&type=template&id=55059238&"
import script from "./BatchesDropDown.vue?vue&type=script&lang=js&"
export * from "./BatchesDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports